export const BORDER_COLORS = [
    "transparent",
    "rgb(17, 17, 17)",
    "rgb(117, 117, 117)",
    "rgb(224, 62, 26)",
    "rgb(247, 151, 34)",
    "rgb(243, 193, 27)",
    "rgb(25, 143, 81)",
    "rgb(12, 140, 233)",
    "rgb(138, 56, 245)",
    "rgb(255, 255, 255)",
];
